/**
 * @file     viewingRequest.ts
 * @purpose  Rental viewing request settings in one place: the follow-up
 *           opt-in wording and its version (stored on every request that ticks
 *           it), the form limits, and the dedupe window.
 */

/**
 * Bump whenever FOLLOWUP_OPT_IN_COPY changes, so an audit reads the exact
 * wording the renter agreed to.
 */
export const VIEWING_FOLLOWUP_CONSENT_VERSION = '2026-10-11-v2';

/** English source of the separate follow-up opt-in (MLS rentals only). */
export const FOLLOWUP_OPT_IN_COPY = 'Relta Real Estate can follow up later about renting or buying.';

/** A repeat request for the same listing from the same email inside this window returns the first. */
export const VIEWING_REQUEST_DEDUPE_HOURS = 24;

export const VIEWING_REQUEST_LIMITS = {
  noteMax: 1000,
  timesMax: 6,
} as const;

export const VIEWING_TIME_WINDOWS = ['morning', 'afternoon', 'evening'] as const;

/** The renter's reusable rental profile (dashboard). The sent screen and the renter email both point here. */
export const RENTAL_PROFILE_PATH = '/dashboard/rentals/profile';
